'use strict';
exports.__esModule = true;
// require('../../css/login.css');
angular.module('smartorg.r6.views.azure-login', [
    'ngRoute',
    'ngCookies'
]).config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/azure-login', {
            template: require('../../template/azure-login.html'),
            controller: 'AzureLoginCtrl'
        });
    }]).factory('rememberMe', ['$cookies',
    function ($cookies) {
        return {
            remember: function (key, value) {
                var expireDate = new Date();
                expireDate.setDate(expireDate.getDate() + 14);
                $cookies.put(key, value, { 'expires': expireDate });
            },
            forget: function (key) {
                $cookies.remove(key);
            },
            read: function (key) {
                return $cookies.get(key);
            }
        };
    }]).controller('AzureLoginCtrl', [
    '$scope', '$location', '$window',
    function ($scope, $location, $window) {
        var urlString = $window.location.search;
        var jwt_token = urlString.substring(urlString.lastIndexOf("?") + 1, urlString.lastIndexOf("&"));
        var TOKEN_COOKIE_KEY = "smartorg_api_jwt";
        var TOKEN_COOKIE_KEY_TIME = "smartorg_api_jwt_time";
        setCookie(TOKEN_COOKIE_KEY, jwt_token, 35);
        setCookie(TOKEN_COOKIE_KEY_TIME, new Date().getTime(), 35);
        function setCookie(cname, cvalue, exmins) {
            var d = new Date();
            d.setTime(d.getTime() + (exmins * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }
        $scope.loggedIn = function () {
            // Should check if needs to go into first page.
            $location.path("/firstpage");
            $scope.$apply();
        };
        $scope.loggedIn();
    }
]);
module.exports = 'smartorg.r6.views.azure-login';
//# sourceMappingURL=azure-login.js.map


// WEBPACK FOOTER //
// ./app/views/azure-login/app/js/plumbing/azure-login.js